import * as React from "react";
import Slider, { Settings } from "react-slick";
import SwiperButton from "~/components/swiper/swiper-button";
import classNames from "classnames";

interface ISliderSwiperProps {
    settings: Settings;
    className?: string;
    buttonClassName?: string;
}

const SliderSwiper: React.FC<ISliderSwiperProps> = props => {
    const buttonBaseClass = "custom-slick-arrow";
    const buttonClasses = classNames(buttonBaseClass, props.buttonClassName);

    return (
        <div className="slider-swiper slider-swiper--hasPaddingBottom">
            <Slider
                nextArrow={<SwiperButton className={buttonClasses} direction="RIGHT" />}
                prevArrow={<SwiperButton className={buttonClasses} direction="LEFT" />}
                draggable
                infinite={false}
                speed={300}
                {...props.settings}
            >
                {props.children}
            </Slider>
        </div>
    );
};

export default SliderSwiper;
